import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "title-wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "default-count" }
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = { class: "dropdown-button" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "spinner"
}
const _hoisted_9 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 2,
  class: "table-wrapper table-wrapper--contacts scroll-wrapper"
}
const _hoisted_12 = { class: "table-default" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = { class: "text-highlighted" }
const _hoisted_16 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title-main" }, "Contacts", -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.plural($setup.contactlist.length, "Contact")), 1)
      ]),
      _createElementVNode("button", {
        class: "button default primary export-btn",
        onClick: $setup.openExportModal
      }, "Export Contacts")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode($setup["DropDown"], null, {
        control: _withCtx(() => [
          _createElementVNode("button", _hoisted_6, "Contact status is " + _toDisplayString($setup.activeFilter.label), 1)
        ]),
        dropdown: _withCtx(() => [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                onClick: ($event: any) => ($setup.changeFilter(item)),
                class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter.label === item.label })
              }, _toDisplayString(item.label), 11, _hoisted_7))
            }), 256))
          ])
        ]),
        _: 1
      }),
      _createVNode($setup["InputSearch"], {
        class: "search",
        modelValue: $setup.searchQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
        placeholder: "Search",
        theme: "filter"
      }, null, 8, ["modelValue"])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
      : ($setup.contactlist.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("img", {
              class: "empty-block--icon",
              src: require('@/assets/icons/contacts-slim.svg')
            }, null, 8, _hoisted_10),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "Your contact list is empty", -1))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("table", _hoisted_12, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.titles, (item, index) => {
                    return (_openBlock(), _createElementBlock("th", { key: index }, _toDisplayString(item.text), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.contactlist, (row, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    onClick: ($event: any) => ($setup.onRow(row._id))
                  }, [
                    _createElementVNode("td", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, _toDisplayString(row?.firstName) + " " + _toDisplayString(row?.lastName), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(row?.detailsId?.postcode? row?.detailsId?.postcode
: row?.detailsId?.state), 1),
                    _createElementVNode("td", null, _toDisplayString(row?.email), 1),
                    _createElementVNode("td", null, _toDisplayString(row?.phone), 1),
                    _createElementVNode("td", null, [
                      _createVNode($setup["ContactStatusBadge"], {
                        contactStatuses: row?.detailsId?.contactStatuses,
                        estateId: $setup.estateId
                      }, null, 8, ["contactStatuses", "estateId"])
                    ]),
                    ($setup.estateHasCollaborators)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(row?.business?.name || "-"), 1))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_13))
                }), 128))
              ])
            ])
          ])),
    _createVNode($setup["ExportContactsModal"], {
      "is-open": $setup.isExportModalOpen,
      "estate-id": $setup.estateId,
      onClose: $setup.closeExportModal
    }, null, 8, ["is-open", "estate-id"])
  ]))
}